import React, { Component } from 'react';
import { Nav, Navbar } from 'react-bootstrap';

export default class PageFooter extends Component {
  render() {
    return (
      // <Navbar expand="lg" bg="light" variant="light">
      //   <Nav className="m-auto">
      //   <Navbar.Text>@All rights reserved.</Navbar.Text>
      //   </Nav>
      // </Navbar>
      <div className={this.props.className}>
        ©2021 by Zack. All rights reserved.
      </div >
    );
  }
}
